module.exports = __webpack_public_path__ + "static/img/pic23.1.9b38404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic23.1.png
// module id = WxWa
// module chunks = 0